import React from "react";
import ButtonCommonComponent from "../common/ButtonCommonComponent";
import CommonFiveTextDetails from "../common/CommonFiveTextDetails";
import DisplaySelectedOptionsList from "../common/DisplaySelectedOptionsList";

const optionsSkill = [
  { value: "Skill Name 1", label: "Skill Name 1" },
  { value: "Skill Name 2", label: "Skill Name 2" },
  { value: "Skill Name 3", label: "Skill Name 3" },
];

export default function ClientDashboardCard({ cardData }) {
  return (
    <div className="mt-common-card mt-common-card--client-dash-req">
      <div className="custom-d-flex align-items-center justify-content-between mt-common-card__content-block-1">
        <div>
          <h2 className="font-24-NunitoSans-600 mb-27">
            3 MERN Stack Developers
          </h2>
          <CommonFiveTextDetails />
        </div>
        <div className="mobile-d-flex">
          <p className="font-36-NunitoSans-800 text-right">
            24
            <span className="font-24-NunitoSans-600 ml-15">
              $ /Hr /Resource
            </span>
          </p>
        </div>
      </div>
      <hr className="mt-common-card__hr" />
      <div className="mt-common-card__content-block-2">
        <p className="font-18-nunito-light mt-common-card__content-block-2__text-1">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat.
        </p>
        <div className="custom-d-flex justify-content-between">
          <div className="custom-d-flex align-items-start">
            <p className="font-14-NunitoSans-800 mt-common-card__content-block-2__text-2">
              Key Skills
            </p>

            <DisplaySelectedOptionsList
              displayListSelected={optionsSkill}
              isDisplayRemoveIcon={false}
            />
          </div>

          <div className="mobile-text-right">
            {cardData.isCompleted ? (
              <ButtonCommonComponent
                extraClassName="login-btn--req-border mb-25"
                onClick={() => console.log("Fulfilled")}
                text="Fulfilled"
                isDisabled={true}
              />
            ) : cardData.isLive ? (
              <ButtonCommonComponent
                extraClassName="login-btn--req-border mb-25"
                onClick={() => console.log("Make it Live")}
                text="Make it Live"
              />
            ) : (
              <ButtonCommonComponent
                extraClassName="login-btn--req-mark-fill mb-25"
                onClick={() => console.log("Mark it Fulfilled")}
                text="Mark it Fulfilled"
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
